import styles from './SalaryType.less';

import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';

import { ScreenReaderOnly } from 'seek-style-guide/react';
import QualifiedLink from 'QualifiedLink/QualifiedLink';

export default class SalaryType extends Component {

  static propTypes = {
    salaryTypes: PropTypes.arrayOf(
      PropTypes.shape({
        isActive: PropTypes.bool.isRequired,
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        refineParams: PropTypes.object
      })
    ).isRequired,
    className: PropTypes.string
  };

  static defaultProps = {
    className: ''
  };

  render() {
    const { salaryTypes, className, ...props } = this.props;
    const activeSalaryTypes = salaryTypes.filter(salaryType => salaryType.isActive);
    const activeValue = activeSalaryTypes[0].value;

    return (
      <section {...props} className={classnames(styles.root, className)}>
        <ScreenReaderOnly><h1>Salary type</h1></ScreenReaderOnly>
        <ul className={`${styles.list} ${styles[`${activeValue}IsActive`]}`} role="radiogroup">
          {
            salaryTypes.map(salaryType => {
              const { isActive, value, label, refineParams } = salaryType;

              // We always provide a link here, even for the selected item
              // so screen readers maintain radio button selection context
              return (
                <li className={styles.item} key={value} role="presentation">
                  <QualifiedLink
                    role="radio"
                    aria-label={`Salary type, ${label}`}
                    aria-checked={isActive}
                    path={!isActive ? '/jobs' : null}
                    className={isActive ? styles.activeLink : styles.link}
                    params={refineParams}
                    {...(isActive ? { 'data-automation': 'refineActiveSalaryType' } : {})}>
                    {label}
                  </QualifiedLink>
                </li>
              );
            })
          }
        </ul>
      </section>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/Search/components/RefineBar/components/SalaryType/SalaryType.js
 **/